module.exports = __webpack_public_path__ + "img/Italy.78dad7d7.svg";